import React, { useState } from 'react';
import TableRow from "./TableRow";
import BookingDetailsList from "../../Modules/Bookings/Components/BookingDetailsList";

const TableItem = (props) => {

    const {ActionsCellComponent, row} = props;

    let [isInformationRowOpen, setInformationRowOpen] = useState(false);

    const handleInformationRowToggle = (event) => {
        setInformationRowOpen(current => !current)
        props.onInformationRowToggle()
    }

    const getCells = (row) => {
        let rowCells = Object.keys(props.columnData)
            .map(key => {
                let column = props.columnData[key];

                if (column.key === 'actions') {
                    return <ActionsCellComponent
                        key="booking-actions-cell"
                        row={row}
                        onViewClick={handleInformationRowToggle}
                    />
                }

                if (column.selector) {
                    return column.selector(row);
                }
            });

        return rowCells;
    }

    return (<>
        <tbody
            ref={props.itemRef}
            className={`visit-item ${(props.rowNumber % 2) ? 'odd' : 'even'}`}
        >
            <TableRow rowId={row.id}>
                { getCells(row) }
            </TableRow>

            {isInformationRowOpen && (
                <BookingDetailsList data={row} datatableHack={false}/>
            )}
        </tbody>
    </>)
}

TableItem.defaultProps = {
}

export default TableItem;
